module.exports = __webpack_public_path__ + "img/travel-agency_user-experience-research.b91cc090.jpg";